export default __webpack_public_path__ + "static/media/share.a46c3ab1.svg";